import React from 'react'
import cn from 'classnames'
import SpriteSvg from "../SpriteSvg/SpriteSvg";
import './SideParameters.scss'

function SideParameters ({
	knowledge,
	skill,
	exp,
	dexterity,
	strong,

	knowledgeUp,
	skillUp,
	expUp,
	dexterityUp,
	strongUp,
}){

	return (
		<div className="side-parameters">
			<div className="side-parameters-list">

				<div className="side-parameters-item">
					<div className="param-img">
						<SpriteSvg id={`param-line-${knowledge}`}/>
					</div>
					<div className="param-title">
						<p>Знание</p>
					</div>
					{knowledgeUp &&
						<div className="param-icon">
							<SpriteSvg id='double-arrow-right'/>
						</div>
					}
				</div>

				<div className="side-parameters-item">
					<div className="param-img">
						<SpriteSvg id={`param-line-${skill}`}/>
					</div>
					<div className="param-title">
						<p>Мастерство</p>
					</div>
					{skillUp &&
					<div className="param-icon">
						<SpriteSvg id='double-arrow-right'/>
					</div>
					}
				</div>

				<div className="side-parameters-item">
					<div className="param-img">
						<SpriteSvg id={`param-line-${exp}`}/>
					</div>
					<div className="param-title">
						<p>Опыт</p>
					</div>
					{expUp &&
					<div className="param-icon">
						<SpriteSvg id='double-arrow-right'/>
					</div>
					}
				</div>

				<div className="side-parameters-item">
					<div className="param-img">
						<SpriteSvg id={`param-line-${dexterity}`}/>
					</div>
					<div className="param-title">
						<p>Ловкость</p>
					</div>
					{dexterityUp &&
					<div className="param-icon">
						<SpriteSvg id='double-arrow-right'/>
					</div>
					}
				</div>

				<div className="side-parameters-item">
					<div className="param-img">
						<SpriteSvg id={`param-line-${strong}`}/>
					</div>
					<div className="param-title">
						<p>Сила</p>
					</div>
					{strongUp &&
					<div className="param-icon">
						<SpriteSvg id='double-arrow-right'/>
					</div>
					}
				</div>

			</div>
		</div>
	)
}

export default SideParameters